"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _lib = require("@cimpress/react-components/lib");

var _reactComponents = require("@cimpress/react-components");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CreateSavedSearch = function CreateSavedSearch(_ref) {
  var label = _ref.label,
      showModal = _ref.showModal,
      closeModal = _ref.closeModal,
      onSave = _ref.onSave;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      savedSearchName = _useState2[0],
      setSavedSearchName = _useState2[1];

  var save = function save() {
    var value = savedSearchName === null || savedSearchName === void 0 ? void 0 : savedSearchName.trim();

    if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
      setSavedSearchName('');
      onSave(savedSearchName);
    }
  };

  var cancel = function cancel() {
    setSavedSearchName('');
    closeModal();
  };

  return /*#__PURE__*/_react["default"].createElement(_lib.Modal, {
    show: showModal,
    onRequestHide: cancel,
    title: label,
    closeButton: true,
    footer: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_lib.Button, {
      variant: "default",
      onClick: cancel
    }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_lib.Button, {
      variant: "primary",
      onClick: save
    }, "Save"))
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.TextField, {
    name: "simple",
    label: "Enter filter name",
    value: savedSearchName // capture the text & store in local state of this modal
    ,
    onChange: function onChange(e) {
      return setSavedSearchName(e.target.value);
    }
  }));
};

var _default = CreateSavedSearch;
exports["default"] = _default;